
import { CircleFadingArrowUp } from "lucide-react";
import { formatSubscriptionPeriod } from "../../utils/timeUtils";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
import { AthenaLogo } from "../../Icons/AthenaLogo";

const AccountStatusCard = ({ userData, handleUpgradeClick }) => {
  const isPremium = userData?.isSubbed === true;

  return (
    <div className="flex flex-col gap-4">
      <Typography size="20" weight="sb">Account Status</Typography>

      <div
        className="cursor-pointer w-full border-[2px] border-gray-150 bg-white rounded-[12px] px-6 py-5 flex items-center gap-4"
        onClick={!isPremium ? handleUpgradeClick : undefined}
      >
        <Button
          type="color"
          icon={isPremium ? <AthenaLogo color="#F8F7F4" size={28} /> : <CircleFadingArrowUp size={20} />}
          size="md"
        />
        {isPremium ? (
          <div className="flex flex-col gap-1">
            <Typography size="24" weight="md">Athena Premium</Typography>
            <Typography size="16" weight="md" color="gray-600">
              {formatSubscriptionPeriod(userData.subscriptionStartDate, userData.subscriptionEndDate)}
            </Typography>
          </div>
        ) : (
          <div className="flex flex-col gap-1">
            <Typography size="24" weight="md">Free tier</Typography>
            <Typography size="16" weight="md" color="gray-600">
              Fai l'upgrade! Passa a premium.
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountStatusCard;